export default __webpack_public_path__ + "img/cc48b45768c46f6efc1049ea2cb7949f.svg";